import { STATUS_PILL_MAP } from 'pages/telephony/numberBlocks/add/constants';

export default function StatusPillCellRenderer({ value }) {
    const pill = STATUS_PILL_MAP[value] ?? STATUS_PILL_MAP.Pending;
    return (
        <div
            style={{
                borderRadius: '100px',
                paddingLeft: '4px',
                paddingRight: '12px',
                fontWeight: 500,
                height: '26px',
                display: 'inline-flex',
                alignItems: 'center',
                fontSize: '12px',
                ...pill.tag,
            }}>
            <div
                style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    marginRight: '8px',
                    marginLeft: '6px',
                    flexShrink: 0,
                    ...pill.circle,
                }}
            />
            {value}
        </div>
    );
}
